import { createContext, useContext, useLayoutEffect, useState } from 'react'

// Used primarily in deviceMockup component to override the window size
// to match the size of the device so that the content in its iframe
// gets the correct state of useIsMobile
export const WindowSizeContext = createContext<[number, number] | undefined>(
  undefined,
)

export const useWindowSize = () => {
  const [size, setSize] = useState<[height: number, width: number]>([0, 0])
  const windowSizeFromContext = useContext(WindowSizeContext)

  useLayoutEffect(() => {
    if (windowSizeFromContext) {
      setSize(windowSizeFromContext)
      return
    }
    const updateSize = () => {
      setSize([window.innerHeight, window.innerWidth])
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [windowSizeFromContext])

  return size
}
